const safeMatch =
  (pos: number) =>
  (regex: RegExp) =>
  (str: string): string | undefined =>
    (str.match(regex) ?? [])[pos] as string | undefined;

export default safeMatch;
